// @flow

import React from 'react'
import styled, { css } from 'styled-components'
import { mediaMin } from 'frontend_core/dist/styles/media'
import {
  fontSize,
  spacing,
  borderRadius,
} from 'frontend_core/dist/styles/variables'
import Colors from 'components/styles/colors'
import OptimizedImage from 'components/atoms/OptimizedImage'
import CheckLabel from 'components/atoms/CheckLabel'
import { imagePath } from 'frontend_core/dist/helpers/image'

const CardSelectComponent = styled.div`
  border-radius: ${borderRadius}px;
`

const CardSelectImageWrapper = styled.div`
  position: relative;
  overflow: hidden;
  border-radius: ${borderRadius}px;
`

const OptimizedImageWrapper = styled.div`
  position: relative;
  padding-top: 66.666%;
  opacity: 0.6;
  transition: opacity 0.15s;

  &:hover {
    opacity: 1;
  }

  ${props =>
    props.checked &&
    css`
      opacity: 1;
    `};
`

const CardSelectCheckLabelWrapper = styled.div`
  position: absolute;
  right: 8px;
  bottom: 8px;
`

const CardSelectTitle = styled.h3`
  color: ${Colors.black};
  font-size: ${fontSize.small_2}px;
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  ${mediaMin.phone`
    font-size: ${fontSize.small_3}px;
  `};
`

const CardContent = styled.div`
  padding-top: ${spacing.small_2}px;
`

const CardSelectInput = styled.input`
  display: none;
`

const CardSelectLabel = styled.label`
  position: relative;
  vertical-align: middle;
  cursor: pointer;
`

export type PropTypes = {
  id: string,
  name: string,
  thumbnail: string,
  checked: boolean,
  onClickAddFavoriteList: Function,
  onClickRemoveFavoriteList: Function,
}

export default (props: PropTypes) => {
  const {
    id,
    name,
    thumbnail,
    checked,
    onClickAddFavoriteList,
    onClickRemoveFavoriteList,
  } = props

  return (
    <CardSelectComponent>
      <CardSelectInput
        type="checkbox"
        id={`favorite_item_${id}`}
        checked={checked}
        readOnly
      />
      <CardSelectLabel
        htmlFor={`favorite_item_${id}`}
        onClick={() => {
          if (checked) {
            onClickRemoveFavoriteList(id)
          } else {
            onClickAddFavoriteList(id)
          }
        }}
      >
        <CardSelectImageWrapper>
          <OptimizedImageWrapper checked={checked}>
            {thumbnail !== '' && (
              <OptimizedImage
                src={thumbnail || imagePath('common/noimage_search.png')}
                type="cover"
                alt={name}
              />
            )}
          </OptimizedImageWrapper>
          <CardSelectCheckLabelWrapper>
            <CheckLabel medium checked={checked} />
          </CardSelectCheckLabelWrapper>
        </CardSelectImageWrapper>
        <CardContent>
          <CardSelectTitle>{name}</CardSelectTitle>
        </CardContent>
      </CardSelectLabel>
    </CardSelectComponent>
  )
}



// WEBPACK FOOTER //
// ./src/components/molecules/CardSelect/index.jsx